"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PrebindResolver = (function () {
    function PrebindResolver() {
        this.prebindAppliedValue = "appliedPrebind";
        this.helpers = {};
    }
    PrebindResolver.prototype.registerPrebindHelper = function (helperName, handler) {
        if (typeof (helperName) !== "string" || helperName === "") {
            throw "You must define a name for the prebind helper.";
        }
        if (typeof (handler) === "undefined" || handler === null) {
            throw "You must define a handler for the prebind helper.";
        }
        if (this.helpers.hasOwnProperty(helperName)) {
            console.warn("A prebind handler already exists for '" + helperName + "'. It will be ignored");
            return;
        }
        this.helpers[helperName] = handler;
    };
    PrebindResolver.prototype.hasHelper = function (helperName) {
        return this.helpers.hasOwnProperty(helperName);
    };
    PrebindResolver.prototype.getHelper = function (helperName) {
        if (!this.hasHelper(helperName)) {
            throw "'" + helperName + "' has no registered helper.";
        }
        return this.helpers[helperName];
    };
    PrebindResolver.prototype.hasNotAppliedPrebind = function (element) {
        return element.dataset[this.prebindAppliedValue] !== "true";
    };
    PrebindResolver.prototype.applyToElement = function (element) {
        var _this = this;
        try {
            var attributes = this.getPrebindingAttributesForElement(element);
            if (attributes.length > 0) {
                element.dataset[this.prebindAppliedValue] = "true";
            }
            attributes.forEach(function (attributes) { return _this.applyPrebindToElement(attributes, element); });
        }
        catch (exception) {
            console.warn("(CoveoForSitecore) prebinding failed on element.", element, exception);
        }
    };
    PrebindResolver.prototype.getPrebindingAttributesForElement = function (element) {
        var _this = this;
        return this.getAllPrebindingAttributesNames(element).map(function (key) {
            var methodName = element.dataset[key];
            var attribute = _this.lowerCaseFirstCharacter(_this.removePrebindPrefix(key));
            return {
                attribute: attribute,
                attributeValue: element.dataset[attribute] || "",
                method: _this.getHelper(methodName)
            };
        });
    };
    PrebindResolver.prototype.getAllPrebindingAttributesNames = function (element) {
        var _this = this;
        return Object.keys(element.dataset)
            .filter(function (key) { return _this.stringStartsWithPrebindingString(key); })
            .filter(function (key) {
            var helperName = element.dataset[key];
            return _this.filterAndWarnNonExistingHelperName(helperName, element);
        });
    };
    PrebindResolver.prototype.stringStartsWithPrebindingString = function (value) {
        return value.lastIndexOf(PrebindResolver.prebindString) === 0;
    };
    PrebindResolver.prototype.filterAndWarnNonExistingHelperName = function (helperName, element) {
        var hasHelperWithName = this.hasHelper(helperName);
        if (!hasHelperWithName) {
            console.warn("(CoveoForSitecore) an unregistered prebinding '" + helperName + "' was set on the element. Register this method using Prebinding.registerPrebindHelper(\"" + helperName + "\", handler).", element);
        }
        return hasHelperWithName;
    };
    PrebindResolver.prototype.removePrebindPrefix = function (attributeName) {
        return attributeName.substring(PrebindResolver.prebindString.length);
    };
    PrebindResolver.prototype.lowerCaseFirstCharacter = function (value) {
        return value.charAt(0).toLowerCase() + value.slice(1);
    };
    PrebindResolver.prototype.applyPrebindToElement = function (prebind, element) {
        element.dataset[prebind.attribute] = prebind.method(prebind.attributeValue, element);
    };
    return PrebindResolver;
}());
PrebindResolver.prebindString = "prebind";
exports.PrebindResolver = PrebindResolver;



//////////////////
// WEBPACK FOOTER
// ./src/resolvers/prebinding/PrebindResolver.ts
// module id = 36
// module chunks = 13 14